import React from 'react';
import { getImg } from '@/pages/home/_config/getImgs';
import '@/pages/home/assets/scss/components/nodata.scss';
interface TNoDataProps {
  className?: string;
  title?: React.ReactNode;
  text?: React.ReactNode;
}
export default function NoData(props: TNoDataProps) {
  const { className = '', title, text } = props || {};
  return (
    <div className={`dbh-search-nodata ${className}`}>
      <img src={getImg('no-data')} className="dbh-search-nodata-img" />
      <div className="dbh-search-nodata-title">{title ? title : 'No results found'}</div>
      <div className="dbh-search-nodata-text">
        {
          text ? text : <>We couldn’t find what you searched for.<br />Try seaching again.</>
        }
      </div>
    </div>
  );
}
